import { SET_ACTIVE_DRAFT_SUGGESTION } from './actions/index';
import { SET_DEPARTMENT_LIST } from './actions/index';
import SessionStorageManager from 'utils/session-storage-manager';
import { SET_UPDATE_SUGGESTION_DETAILS } from './actions/index';

const initialState = {
  activeDraftSuggestion: {
    staticData: true,
    draft: {
      id: null,
      name: null,
      productCount: null,
    },
    suggestion: {
      id: null,
      name: null,
      productCount: null,
    },
  },
  departmentList: {
    list: [],
    commonGenderId: '',
    commonCollectionId: '',
  },
  updatedSuggestionDetails: {
    id: null,
    action: '',
  },
};

const userDefaultData = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACTIVE_DRAFT_SUGGESTION: {
      let prevActiveDraft =
        SessionStorageManager.getSessionStorage('activeDraft');
      if (prevActiveDraft !== action.payload.draft.id) {
        if (!SessionStorageManager.getSessionStorage('showSelectDraft')) {
          SessionStorageManager.setSessionStorage('showSelectDraft', true);
        }

        if (action.payload.draft?.draftCount === 1) {
          SessionStorageManager.setSessionStorage('showSelectDraft', false);
        }
        SessionStorageManager.setSessionStorage(
          'activeDraft',
          action.payload.draft?.id
        );
      }
      return { ...state, activeDraftSuggestion: action.payload };
    }
    case SET_DEPARTMENT_LIST:
      return { ...state, departmentList: action.payload };
    case SET_UPDATE_SUGGESTION_DETAILS:
      return { ...state, updatedSuggestionDetails: action.payload };
    default:
      return state;
  }
};

export default userDefaultData;
